import { IsNotEmpty, IsDefined } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AgentMarketDataService extends DataService<typeof Model.Bookings.Logic.ViewModels.AgentMarketItem, Model.Bookings.Logic.ViewModels.AgentMarketItem, AgentMarketItem> {
	protected map(entity: Model.Bookings.Logic.ViewModels.AgentMarketItem): AgentMarketItem {
		return new AgentMarketItemModel(entity);
	}

	private id = -1;
	static make(ctx?: any): AgentMarketDataService {
		return new AgentMarketDataService(ctx, ctx => ctx.AgentMarkets, false);
	}

	add(agent: AgentItem): Promise<AgentMarketItem> {
		const entity = new Model.Bookings.Logic.ViewModels.AgentMarketItem();
		if (agent.id > 0) {
			entity.agentId = agent.id;
		} else {
			entity.agent = agent.entity;
		}
		entity.id = this.id--;

		return this.create(() => entity);
	}
}

export class AgentMarketItemModel extends EntityModel<Model.Bookings.Logic.ViewModels.AgentMarketItem, AgentMarketItem> implements AgentMarketItem {
	@property<AgentMarketItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<AgentMarketItemModel>(o => o.entity.agentId, (o, value) => o.entity.agentId = value)
	//@IsDefined({ message: "agent is required" })
	public agentId: number;

	@property<AgentMarketItemModel>(o => o.entity.marketId, (o, value) => o.entity.marketId = value)
	@IsDefined({ message: 'Market is required' })
	public marketId: number;

	@property<AgentMarketItemModel>(o => o.entity.marketName, (o, value) => o.entity.marketName = value)
	@IsDefined({ message: 'MarketName is required' })
	public marketName: string;
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-markets/agent-market-form.data.ts